<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Temperature Check', apiMethod: 'TemperatureChecks', form: () => import('../forms/TemperatureCheckForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                ],
                tabs: [
                ],
                mainForm: () => import('../forms/TemperatureCheckForm'),
                claimName: 'TemperatureChecks',
                apiMethod: 'TemperatureChecks',
            }
        }
    };
</script>
